module.exports = __webpack_public_path__ + "img/26_111.94c25c86.png";